__turbopack_context__.v({
  "card": "styles-module-scss-module__IPXX7a__card",
  "ctaBtn": "styles-module-scss-module__IPXX7a__ctaBtn",
  "root": "styles-module-scss-module__IPXX7a__root",
});
